import styled from "styled-components";

export const Container = styled.div`
  background-color: #ffffff;
  padding: 0.5rem 1rem;
  width: 100% fit-content;

  .formItem {
    margin: 15px 0;
    
    .formInput {
      margin-top: 5px;
    }
    
    span {
      display: block;
      margin-bottom: 5px;
    }
  }

  .formData {
    margin-top: 5px;
    padding-top: 5px;
  }
  
`;
export const Options = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 1rem;
`;
export const CreateReportBtn = styled.form`
  margin-top: 1rem;
`;
export const ViewOnlyDiv = styled.div`
box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: 'tnum';
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 0;
    padding: 4px 11px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    line-height: 1.5715;
    background-color: #fff;
    background-image: none;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    transition: all 0.3s;

`;
export const RequiredAsterisk = styled.span`
  color: red;
  font-size: larger;
  display: inline-block;
  vertical-align: middle;
  padding-right:2px
`;